import { useQuery } from 'react-query';
import axios from 'axios';
import { Dealer, IDealerLocatorPageContent } from 'interfaces/dealerLocator';

export function useDealerLocatorDealers(
  zipcode: string | undefined,
  coordinates?: { latitude: number; longitude: number }
) {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const productDivisionCode = isHonda ? 'A' : 'B';
  const queryKey = coordinates
    ? `/platform/api/v1/dealers?productDivisionCode=${productDivisionCode}&getDDPOnly=false&lat=${coordinates?.latitude.toString()}&long=${coordinates?.longitude.toString()}&maxResults=16`
    : `/platform/api/v1/dealers?productDivisionCode=${productDivisionCode}&getDDPOnly=false&zipCode=${zipcode}&maxResults=16`;
  return useQuery<Dealer[], Error>(
    queryKey,
    async () => {
      let response;
      if (zipcode) {
        response = await axios.get(queryKey);

        return response.data as Dealer[];
      }
      return response as unknown as Dealer[];
    },
    {
      staleTime: Infinity, //adding staleTime to avoid re fetching the endpoint each time the user refocus the page.
      enabled: true,
    }
  );
}

export function useDealerLocatorPageContent() {
  const queryKey = '/platform/api/v1/dealersPageContent';
  return useQuery<IDealerLocatorPageContent, Error>(
    queryKey,
    async () => {
      let response;
      response = await axios.get(queryKey);
      return response.data as IDealerLocatorPageContent;
    },
    {
      staleTime: Infinity, //adding staleTime to avoid re fetching the endpoint each time the user refocus the page.
    }
  );
}
